export const callControlRouters = [
  {
    path: '/seats',
    component: resolve => require(['@/components/Index'], resolve),
    name: 'CallControl',
    meta:{
      requireAuth: true,
      title: '坐席管理'
    },
    hidden: true,
    children: [
      { 
        path: 'dept', 
        component: resolve => require(['@/pageCall/seats/dept/index'],resolve), 
        name: 'CallDept', 
        meta:{
          requireAuth: true,
          title: '部门管理'
        },
      },
      { 
        path: 'user', 
        component: resolve => require(['@/pageCall/seats/user/index'],resolve), 
        name: 'CallUser', 
        meta:{
          requireAuth: true,
          title: '用户管理'
        },
      },
      { 
        path: 'role', 
        component: resolve => require(['@/pageCall/seats/role/index'],resolve), 
        name: 'CallRole', 
        meta:{
          requireAuth: true,
          title: '角色管理'
        },
      },
      { 
        path: 'config', 
        component: resolve => require(['@/pageCall/seats/config/index'],resolve), 
        name: 'CallConfig', 
        meta:{
          requireAuth: true,
          title: '坐席配置'
        },
      },
      { 
        path: 'state', 
        component: resolve => require(['@/pageCall/seats/state/index'],resolve), 
        name: 'CallState', 
        meta:{
          requireAuth: true,
          title: '坐席状态统计'
        },
      },
    ]
  },
  {
    path: '/recorder',
    component: resolve => require(['@/components/Index'], resolve),
    name: 'CallRecorder',
    meta: {
      requireAuth: true,
      title: '通话录音'
    },
    hidden: true,
    children: [
      { 
        path: 'calllog', 
        component: resolve => require(['@/pageCall/recorder/calllog/index'],resolve), 
        name: 'Calllog', 
        meta:{
          requireAuth: true,
          title: '通话记录'
        },
      },
      { 
        path: 'downTask', 
        component: resolve => require(['@/pageCall/recorder/task/index'],resolve), 
        name: 'Calltask', 
        meta:{
          requireAuth: true,
          title: '下载任务'
        },
      },
    ]
  },
  {
    path: '/balance',
    component: resolve => require(['@/components/Index'], resolve),
    name: 'CallBalance',
    meta: {
      requireAuth: true,
      title: '结算中心'
    },
    hidden: true,
    children: [
      { 
        path: 'prediction', 
        component: resolve => require(['@/pageCall/balance/prediction/index'],resolve), 
        name: 'CallPrediction', 
        meta:{
          requireAuth: true,
          title: '预测式外呼结算'
        },
      },
    ]
  },
  {
    path: '/customer',
    component: resolve => require(['@/components/Index'], resolve),
    name: 'customer',
    meta: {
      requireAuth: true
    },
    hidden: true,
    children: [
      {
        path: 'customer',
        component: resolve => require(['@/pageCall/customer/customer/index'], resolve),
        name: 'Customer',
        meta: {
          requireAuth: true,
          title: '客户资料'
        },
      },
      {
        path: 'customerDetail',
        component: resolve => require(['@/pageCall/customer/customer/pageCompontents/CustomerDetail'], resolve),
        name: 'CustomerDetail',
        meta: {
          requireAuth: true,
          title: '客户详情'
        },
      },
      {
        path: 'outboundContent',
        component: resolve => require(['@/pageCall/customer/outboundContent/index'], resolve),
        name: 'OutboundContent',
        meta: {
          requireAuth: true,
          title: '备注内容'
        },
      },
    ]
  },
  {
    path: '/forecastCall',
    component: resolve => require(['@/components/Index'], resolve),
    name: 'forecastCall',
    meta: {
      requireAuth: true
    },
    hidden: true,
    children: [
      {
        path: 'task',
        component: resolve => require(['@/pageCall/forecastCall/task/index'], resolve),
        name: 'ForecastCallTask',
        meta: {
          requireAuth: true,
          title: '任务管理'
        },
      },
      {
        path: 'checkResult/:taskId',
        component: resolve => require(['@/pageCall/forecastCall/task/pageCompontents/checkResult'], resolve),
        name: 'CheckResult',
        meta: {
          requireAuth: true,
          title: '查看结果'
        },
      },
    ]
  },
]


// WEBPACK FOOTER //
// ./src/router/callControl.js